import React from 'react';
import classNames from 'classnames';

export default function Tile({
  title,
  description,
  icon: Icon,
  onClick,
  selected = false,
  className
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'relative flex flex-col items-start p-6 text-left transition-all duration-200 rounded-xl border group cursor-pointer',
        selected
          ? 'bg-indigo-500/10 border-indigo-500 ring-1 ring-indigo-500'
          : 'bg-gray-800 border-white/10 hover:border-indigo-500/50 hover:bg-gray-800/80',
        className
      )}
    >
      {Icon && (
        <div className={classNames(
          'mb-4 p-2 rounded-lg',
          selected ? 'bg-indigo-500 text-white' : 'bg-gray-700 text-gray-300 group-hover:text-white'
        )}>
          <Icon className="w-6 h-6" aria-hidden="true" />
        </div>
      )}

      <h3 className={classNames(
        'text-base font-semibold leading-7',
        selected ? 'text-indigo-400' : 'text-white group-hover:text-indigo-400'
      )}>
        {title}
      </h3>

      {description && (
        <p className={classNames(
          'mt-1 text-sm leading-6',
          selected ? 'text-indigo-200' : 'text-gray-400 group-hover:text-gray-300'
        )}>
          {description}
        </p>
      )}
    </button>
  );
}
